"use client";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useState } from "react";
import { FaBars } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import { motion, AnimatePresence } from "framer-motion";

const Navbar = () => {
  const activeRoute = usePathname();
  const [open, setOpen] = useState(false);

  const navItems = [
    { path: "/", title: "Home" },
    { path: "/about", title: "About" },
    { path: "/project", title: "Projects" },
    { path: "/certificates", title: "Certificates" },
    { path: "/blog", title: "Blogs" },
    { path: "/contact", title: "Contact" },
  ];

  return (
    <nav className="fixed bg-base-300 z-50 w-full shadow-md">
      <div className="max-w-[1440px] md:w-11/12 mx-auto flex items-center justify-between py-3 px-4">
        {/* Logo */}
        <div className="flex items-center">
          <Link href="/">
            <Image
              width={100}
              height={100}
              src="https://i.ibb.co/yqsB5WK/protfolio-logo-removebg-preview.png"
              alt="Logo"
            />
          </Link>
        </div>

        {/* Desktop Menu */}
        <div className="hidden lg:flex">
          <ul className="flex items-center gap-6 font-medium">
            {navItems.map((item) => (
              <li key={item.path}>
                <Link
                  href={item.path}
                  className={`px-2 transition ${
                    item.path === activeRoute
                      ? "text-rose-500"
                      : " hover:text-rose-500"
                  }`}
                >
                  {item.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Mobile Hamburger */}
        <div className="lg:hidden">
          <button aria-label="close menu" onClick={() => setOpen(!open)}>
            {open ? (
              <RxCross2 className="w-6 h-6 " />
            ) : (
              <FaBars className="w-6 h-6 " />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Dropdown with Animation */}
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ duration: 0.3 }}
            className="fixed top-0 right-0 h-full w-2/3 bg-base-300 shadow-lg z-50 lg:hidden"
          >
            <div className="flex justify-between items-center px-6 py-4 border-b">
              {/* <h2 className="text-lg font-semibold">Menu</h2> */}
              <Link href="/">
                <Image
                  width={100}
                  height={100}
                  src="https://i.ibb.co/yqsB5WK/protfolio-logo-removebg-preview.png"
                  alt="Logo"
                />
              </Link>
              <button aria-label="Close menu" onClick={() => setOpen(false)}>
                <RxCross2 className="w-6 h-6 " />
              </button>
            </div>
            <ul className="flex flex-col gap-4 px-6 py-6">
              {navItems.map((item) => (
                <li key={item.path}>
                  <Link
                    href={item.path}
                    className={`block py-2 text-lg transition ${
                      item.path === activeRoute
                        ? "text-rose-500"
                        : " hover:text-rose-500"
                    }`}
                    onClick={() => setOpen(false)}
                  >
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
